import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const manageProjectsDirectoryRoute: InvariantJiraRoute = {
	name: 'projects-directory-manage',
	path: '/jira/settings/projects/manage',
};
